import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Button, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

interface OrganizingDocumentsLearnMoreProps {
  navToDocs: () => void
}

const OrganizingDocumentsLearnMore: React.FC<OrganizingDocumentsLearnMoreProps> = (props) => {
  const { navToDocs } = props;
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Message info attached="top" className={styles.highlightsItemMsgWithBtn}>
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Header.Subheader > 
                  <p className={styles.learnMoreAccordionTextEmphasis} style={{marginTop: ".5em"}}>
                    AgeReady provides a document storage and retrieval feature. 
                  </p>
                </Header.Subheader>
              </Header>
            </Message>
            <Button attached="bottom" className={`${styles.learnMoreAccordionAttachedBtn} ${styles.nextButton}`}
              content="Click Here to Navigate to the Document View"
              onClick={() => navToDocs()}
            />
          </Grid.Row>
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >             
                  <Image src={`${iconRoute}GroupDocuments.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > GROUP TOGETHER </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                      <b>Keep all similar documents together.</b><br/>
                      It is important to keep everything in one place so it can be easily located.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column width={10} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}TrashBin.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > CLEAR OUT EXCESS </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                      <b>Keep only necessary documents.</b> <br/>
                      A lot of this paperwork may be junk or outdated information. To keep things organized, you and the 
                      older adult should go through everything and shred or recycle things you do not need.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}SortAndOrganize.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > SORT & ORGANIZE </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                      <b>Sort and organize important paperwork.</b><br/>
                        Using a folder system can be very helpful in organizing important documents. Make sure everything is 
                        labeled, and it may even be helpful to alphabetize it. If the documents are stored digitally, make 
                        sure to back them up on a hard drive. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}TrackBills.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > TRACK BILLS </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                      <b>Keep track of bills - amounts and due dates.</b><br/>
                      If there are bills that need to be paid, it is helpful to keep all this information listed on paper or 
                      in a spreadsheet. Be sure to include login information for things to be accessed online. Setting up 
                      automatic payments for bills is also a good idea to ensure no interruption if the older adult is unable 
                      to tend to them. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Learn More About Document Organization </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}OrganizingDocumentsLearnMore1.JPG)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(OrganizingDocumentsLearnMore);
